__turbopack_context__.v({
  "body": "index-module-scss-module__KmnjyW__body",
  "content": "index-module-scss-module__KmnjyW__content",
  "contentBox": "index-module-scss-module__KmnjyW__contentBox",
  "content__withTopBanner": "index-module-scss-module__KmnjyW__content__withTopBanner",
  "influenceHubPage": "index-module-scss-module__KmnjyW__influenceHubPage",
  "progressBar": "index-module-scss-module__KmnjyW__progressBar",
  "root": "index-module-scss-module__KmnjyW__root",
  "root__withTopBanner": "index-module-scss-module__KmnjyW__root__withTopBanner",
});
